import { StorageKey, setSessionStorage } from '@utils/StorageUtils';
import { SideFiltersState } from '../../reducers/side-filters/SideFiltersReducer';
import { SideFiltersTypes } from '../Type';

export const updateSideFilters = (payload: SideFiltersState) => {
  return (dispatch: any) => {
    dispatch({
      type: SideFiltersTypes.SideFiltersUpdate,
      payload,
    });

    setSessionStorage(StorageKey.SideFilters, JSON.stringify(payload));
  };
};
